module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "u-form u-form--light",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createNote($event)
      }
    }
  }, [_c('div', {
    staticClass: "u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "new-note-title"
    }
  }, [_vm._v("\n      Title*\n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('title')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.title),
      expression: "note.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    ref: "title",
    attrs: {
      "id": "new-note-title",
      "name": "title",
      "type": "text",
      "placeholder": "Provide a title for the note",
      "required": ""
    },
    domProps: {
      "value": (_vm.note.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "new-note-body"
    }
  }, [_vm._v("\n      Note*\n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('note')),
      expression: "errors.has('note')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('note')))])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.body),
      expression: "note.body"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    attrs: {
      "id": "new-note-body",
      "name": "note",
      "placeholder": "Provide content for the note",
      "rows": "4",
      "required": ""
    },
    domProps: {
      "value": (_vm.note.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.body = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "new-note-attachments"
    }
  }, [_vm._v("\n      Attachments\n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attachments')),
      expression: "errors.has('attachments')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('attachments')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        mimes: _vm.validMimeTypes
      }),
      expression: "{ mimes: validMimeTypes }"
    }],
    ref: "fileInput",
    staticClass: "u-hide",
    attrs: {
      "type": "file",
      "id": "new-note-attachments",
      "name": "attachments",
      "multiple": "true"
    },
    on: {
      "change": _vm.uploadTempFiles
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-form-hint u-mb1"
  }, [_vm._v("Upload up to 3 files with the following file types: PDF, CSV, Excel, Word, TXT")]), _vm._v(" "), _c('button', {
    staticClass: "Button Button--outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$refs.fileInput.click()
      }
    }
  }, [_vm._v("\n      Attach Files\n    ")])]), _vm._v(" "), (!!_vm.attachments.length) ? _c('ul', {
    staticClass: "u-mb2"
  }, _vm._l((_vm.attachments), function(attachment, index) {
    return _c('li', [_vm._v("\n      " + _vm._s(attachment.name) + "\n    ")])
  })) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "u-mt4 u-mb4"
  }, [_c('legend', [_vm._v("Tags")]), _vm._v(" "), _vm._l((_vm.noteTypesArray), function(noteType, index) {
    return _c('div', {
      staticClass: "u-mb1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.note.noteTypeIds),
        expression: "note.noteTypeIds"
      }],
      attrs: {
        "id": 'note-type-' + noteType.id,
        "type": "checkbox"
      },
      domProps: {
        "value": noteType.id,
        "checked": Array.isArray(_vm.note.noteTypeIds) ? _vm._i(_vm.note.noteTypeIds, noteType.id) > -1 : (_vm.note.noteTypeIds)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.note.noteTypeIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = noteType.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.note.noteTypeIds = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.note.noteTypeIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.note.noteTypeIds = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'note-type-' + noteType.id
      }
    }, [_vm._v(_vm._s(noteType.name))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "u-mb4"
  }, [_c('label', {
    attrs: {
      "for": "new-note-status"
    }
  }, [_vm._v("Note Type")]), _vm._v(" "), _c('div', {
    staticClass: "js-custom-select u-form-veryShortWrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.status),
      expression: "note.status"
    }],
    attrs: {
      "id": "new-note-status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.note.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "personal"
    }
  }, [_vm._v("Personal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Public")])]), _vm._v(" "), _c('icon', {
    attrs: {
      "icon": "arrow-down"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-form-actions"
  }, [_c('button', {
    staticClass: "Button Button--square",
    attrs: {
      "disabled": _vm.posting,
      "type": "submit"
    }
  }, [_vm._v("Create Note")]), _vm._v(" "), _c('button', {
    staticClass: "Button Button--outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a47faea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/note-form.vue
// module id = 319
// module chunks = 0